import { render, staticRenderFns } from "./MtrlAdd.vue?vue&type=template&id=78bcaf3a&scoped=true&"
import script from "./MtrlAdd.vue?vue&type=script&lang=js&"
export * from "./MtrlAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bcaf3a",
  null
  
)

export default component.exports